import { render, staticRenderFns } from "./UserLoginHandler.vue?vue&type=template&id=39061df4"
import script from "./UserLoginHandler.vue?vue&type=script&lang=js"
export * from "./UserLoginHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/22487/45/StockShop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39061df4')) {
      api.createRecord('39061df4', component.options)
    } else {
      api.reload('39061df4', component.options)
    }
    module.hot.accept("./UserLoginHandler.vue?vue&type=template&id=39061df4", function () {
      api.rerender('39061df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/stockshop/UserLoginHandler.vue"
export default component.exports